import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

var ToolbarPrompt =
/*#__PURE__*/
function (_Component) {
  _inherits(ToolbarPrompt, _Component);

  function ToolbarPrompt(props) {
    var _this;

    _classCallCheck(this, ToolbarPrompt);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarPrompt).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (eventOrValue) {
      var value = eventOrValue;

      if (eventOrValue.target) {
        // eventOrValue is an actual input event
        value = eventOrValue.target.value;
      }

      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        var _this$props;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_this$props = _this.props).onChange.apply(_this$props, [eventOrValue].concat(args));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInputRef", function (input) {
      if (input) {
        _this.input = input;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event, editor, next) {
      if (event.key === 'Enter') {
        event.preventDefault();
        return _this.onSubmit();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        return _this.props.onCancel();
      }

      return next && next();
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSubmit", function () {
      if (_this.input.submit) {
        _this.input.submit();
      } else {
        _this.onSubmit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      if (arguments.length) {
        var _this$props2;

        (_this$props2 = _this.props).onSubmit.apply(_this$props2, arguments);
      } else {
        _this.props.onSubmit(_this.state.value);
      }
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(ToolbarPrompt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoSelect && this.input && this.input.editor) {
        setTimeout(function () {
          return _this2.input.editor.focus();
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.onRendered && prevState.value !== this.state.value) {
        this.props.onRendered();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Input = this.props.input || 'input';
      return React.createElement("div", {
        className: "padding-smaller flexbox width-full flexbox-align-center",
        style: _objectSpread({
          width: 360
        }, this.props.style),
        onMouseDown: function onMouseDown(e) {
          return e.stopPropagation();
        }
      }, this.props.icon && React.createElement("div", {
        className: "flexbox flexbox-align-center padding-horizontal-normal"
      }, React.createElement(this.props.icon, {
        className: 'shade-30',
        size: '16'
      })), React.createElement("div", {
        style: {
          minHeight: 32
        },
        className: "flexbox flexbox-grow flexbox-align-center"
      }, React.createElement(Input, Object.assign({
        ref: this.onInputRef,
        className: "font-size-normal border-none width-full radius-normal margin-right-small background-transparent placeholder-shade-30",
        value: this.state.value,
        onChange: this.onChange,
        title: this.props.placeholder,
        placeholder: this.props.placeholder,
        onSubmit: this.onSubmit,
        onCancel: this.props.onCancel,
        onKeyDown: this.onKeyDown,
        autoFocus: true
      }, this.props.inputProps))), this.props.withSubmit && React.createElement(Button.Primary, {
        className: "margin-left-small",
        slim: true,
        style: {
          minWidth: 'auto',
          alignSelf: 'flex-end'
        },
        onClick: this.onClickSubmit,
        disabled: !this.state.value
      }, this.props.submitLabel));
    }
  }]);

  return ToolbarPrompt;
}(Component);

_defineProperty(ToolbarPrompt, "propTypes", {
  icon: PropTypes.any,
  input: PropTypes.any,
  placeholder: PropTypes.string,
  submitLabel: PropTypes.string,
  value: PropTypes.any,
  autoSelect: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onRendered: PropTypes.func,
  withSubmit: PropTypes.bool,
  inputProps: PropTypes.any,
  style: PropTypes.any
});

_defineProperty(ToolbarPrompt, "defaultProps", {
  placeholder: '',
  submitLabel: 'Send',
  value: '',
  autoSelect: true,
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  withSubmit: true,
  inputProps: {},
  style: {}
});

export { ToolbarPrompt as default };